module.exports = __webpack_public_path__ + "img/japan.8627d5e8.png";